import { NgModule } from '@angular/core';
import { LibBankSecurityIconComponent } from './lib-bank-security-icon.component';

@NgModule({
  declarations: [LibBankSecurityIconComponent],
  imports: [],
  exports: [LibBankSecurityIconComponent],
})
export class LibBankSecurityIconModule {}
